export enum ChevronVariation {
  Dropdown = 'dropdown',
}
